class PromotionalBar extends HTMLElement {
  constructor() {
    super();
    this.slides = null;
    this.closeBtn = null;
    this.bar = null;
    this.currentIndex = 0;
    this.intervalId = null;
    this.storageKey = null;
    this.observer = null;
    this.abortController = new AbortController();
  }

  connectedCallback() {
    const sectionId = this.dataset.sectionId;
    this.storageKey = `promo-bar-closed-${sectionId}`;

    if (sessionStorage.getItem(this.storageKey)) {
      this.setPromoHeight(0);
      this.remove();
      return;
    }

    this.bar = this.querySelector('.cb-promo-bar');
    this.slides = this.querySelectorAll('[data-promo-slide]');
    this.closeBtn = this.querySelector('[data-promo-close]');

    if (!this.bar || this.slides.length === 0) return;

    this.updatePromoHeight();
    this.observeVisibility();

    this.closeBtn?.addEventListener('click', () => this.close(), {
      signal: this.abortController.signal,
    });

    if (this.slides.length > 1) {
      const speed = parseInt(this.bar.dataset.sliderSpeed) || 4;
      this.startSlider(speed);
    }
  }

  disconnectedCallback() {
    this.abortController.abort();
    this.stopSlider();
    this.observer?.disconnect();
    this.setPromoHeight(0);
  }

  startSlider(speed) {
    this.intervalId = setInterval(() => this.nextSlide(), speed * 1000);
  }

  stopSlider() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  nextSlide() {
    const current = this.slides[this.currentIndex];
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    const next = this.slides[nextIndex];

    current.classList.add('cb-promo-bar__slide--exit');
    current.classList.remove('cb-promo-bar__slide--active');
    next.classList.add('cb-promo-bar__slide--active');

    setTimeout(() => {
      current.classList.remove('cb-promo-bar__slide--exit');
    }, 500);

    this.currentIndex = nextIndex;
  }

  setPromoHeight(px) {
    document.documentElement.style.setProperty('--promo-bar-height', `${px}px`);
  }

  updatePromoHeight() {
    this.setPromoHeight(this.bar.offsetHeight);
  }

  observeVisibility() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.setPromoHeight(entry.isIntersecting ? this.bar.offsetHeight : 0);
      },
      { threshold: 0 }
    );
    this.observer.observe(this.bar);
  }

  close() {
    sessionStorage.setItem(this.storageKey, 'true');
    this.setPromoHeight(0);
    this.bar.classList.add('cb-promo-bar--closing');
    this.bar.addEventListener('transitionend', () => this.remove(), {
      once: true,
      signal: this.abortController.signal,
    });
  }
}

if (!customElements.get('promotional-bar')) {
  customElements.define('promotional-bar', PromotionalBar);
}
